<template>
  <div v-if="boughtTogether.length" class="product-page__recommendations">
    <p class="product-page__recommendations-title">
      {{ $t('Customers also buy') }}
    </p>

    <div class="product-page__recommendations-list product-page__recommendations-list--bought-together">
      <ProductCard
        v-for="item in boughtTogether.slice(0, inResponsiveSizes(['xs']) ? 2 : 3)"
        :key="item.id"
        :product="item"
        :show-params="false"
      />
    </div>
  </div>
</template>

<script>
import ProductCard from '@/components/cards/product/ProductCard.vue'
import inResponsiveSizes from '@/helpers/filters/inResponsiveSizes'
import { mapState } from 'vuex'

export default {
  name: 'ProductPageBoughtTogether',
  components: {
    ProductCard,
  },
  computed: {
    ...mapState('productPage', ['boughtTogether']),
  },
  methods: {
    inResponsiveSizes,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';
@import '@/assets/scss/blocks/product-page-recommendations.scss';
</style>
